<template>
  <v-dialog
    v-model="isOpenModalComparaison"
    :scrim="false"
    :fullscreen="$vuetify.breakpoint.mobile"
    :width="'auto'"
    @click:outside="onClose"
  >
    <v-card class="left-vertical-card px-6">
      <div class="d-flex bg-titre">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          {{ titre }}
        </div>
        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <BaseErrorMessage
        v-if="erreur.updateFiltres"
        message="Erreur serveur. merci de réessayer plus tard."
      />
      <v-row
        no-gutters
      >
        <v-col
          class="px-3 pb-6"
          cols="12"
          md="4"
          @click="onAnyClickFiltres"
        >
          <AgrialSelect
            v-model="regionAgrialSelected"
            :clearable="abonnements.culturialAbonne"
            :class="regionAgrialSelected.length > 1 ? $vuetify.breakpoint.mobile ? 'input-multiple-mobile' : 'input-multiple' : 'pt-1'"
            :menu-props="{ top: true, offsetY: true }"
            :disabled="loading.updateFiltres"
            :items="filtresValeursPossibles.regionsAgrial"
            :readonly="!abonnements.culturialAbonne"
            item-text="libelle"
            label="Régions Agrial"
            multiple
            hide-details
            return-object
            @change="updateFiltresAdherent"
          >
            <template
              v-if="!abonnements.culturialAbonne"
              v-slot:prepend-inner
            >
              <v-icon
                class="prepend-icon"
                color="var(--gris-clair)"
                size="18"
              >
                mdi-lock
              </v-icon>
            </template>
          </AgrialSelect>
          <div
            v-if="regionAgrialSelected == null || (regionAgrialSelected!= null && regionAgrialSelected.length<1)"
            class="pl-1 red--text"
          >
            Au moins une région doit être sélectionnée
          </div>
        </v-col>
        <v-col
          v-if="$vuetify.breakpoint.mobile && regionAgrialSelected.length>=3"
          cols="auto"
          class="mb-5 px-3"
        >
          <BaseMessageV2 message="Le chargement des comparaisons augmente avec le nombre de régions sélectionnées" />
        </v-col>
        <v-col
          class="px-3"
          cols="12"
          md="4"
          @click="onAnyClickFiltres"
        >
          <AgrialSelect
            v-model="potentielSolSelected"
            :disabled="loading.updateFiltres"
            :items="filtresValeursPossibles.potentielSol"
            :readonly="!abonnements.culturialAbonne"
            item-text="libelle"
            label="Potentiel de sol"
            class="pt-1"
            return-object
            @change="updateFiltresAdherent"
          >
            <template
              v-if="!abonnements.culturialAbonne"
              v-slot:prepend-inner
            >
              <v-icon
                class="prepend-icon"
                color="var(--gris-clair)"
                size="18"
              >
                mdi-lock
              </v-icon>
            </template>
          </AgrialSelect>
        </v-col>
        <v-col
          class="px-3"
          cols="12"
          md="4"
          @click="onAnyClickFiltres"
        >
          <AgrialSelect
            v-model="typeExploitationSelected"
            :disabled="loading.updateFiltres"
            :items="filtresValeursPossibles.typeExploitation"
            :readonly="!abonnements.culturialAbonne"
            item-text="libelle"
            label="Type d'exploitation"
            class="pt-1"
            return-object
            @change="updateFiltresAdherent"
          >
            <template
              v-if="!abonnements.culturialAbonne"
              v-slot:prepend-inner
            >
              <v-icon
                class="prepend-icon"
                color="var(--gris-clair)"
                size="18"
              >
                mdi-lock
              </v-icon>
            </template>
          </AgrialSelect>
        </v-col>
      </v-row>
      <v-row
        v-if="!$vuetify.breakpoint.mobile"
        no-gutters
      >
        <v-col
          v-if="regionAgrialSelected.length>=3"
          cols="auto"
          class="mb-5 px-3"
        >
          <BaseMessageV2 message="Le chargement des comparaisons augmente avec le nombre de régions sélectionnées" />
        </v-col>
      </v-row>
      <BaseLoader v-if="loading.comparaisonRendement || loading.evolutionRendement" />
      <v-row
        class="mx-3 justify-center"
        no-gutters
      >
        <v-col
          class="pa-3"
          cols="12"
          md="6"
        >
          <ComparaisonRendement
            :is-rendement-incoherent="isRendementIncoherent(culture)"
            :loading="loading.comparaisonRendement"
            :type-culture="culture.typeCulture"
          />
        </v-col>
        <v-col
          class="pa-3"
          cols="12"
          md="6"
        >
          <EvolutionRendements
            :is-rendement-incoherent="isRendementIncoherent(culture)"
            :loading="loading.evolutionRendement"
            :type-culture="culture.typeCulture"
            :has-region-selected="regionAgrialSelected.length>0"
          />
        </v-col>
      </v-row>
      <v-card
        v-if="culture.rendementEnQuintauxParHectare == null && !loading.evolutionRendement && !loading.comparaisonRendement"
        class="d-flex
          align-center
          flex-column pb-6"
      >
        <img
          alt="no-comparaison"
          class="mt-5"
          src="@/assets/no-comparaison.svg"
        >
        <div
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          class=" d-flex flex-column intro texte-gris-fonce  mt-2 text-justify mx-5"
        >
          <span class="text-center">Pas de comparaison disponible pour cette graine et cette récolte.</span>
        </div>
      </v-card>
      <div
        v-if="hasBtnMesOutilsAnalyse"
        class="d-flex justify-center py-3"
      >
        <AgrButton
          class="pa-5 branche"
          @click="onPageOutilsAnalyse()"
        >
          Voir ma synthèse
        </AgrButton>
      </div>
      <div
        class="d-flex justify-center asterix mt-3 pb-16 pb-md-3"
      >
        * Evolution par rapport à l’année précédente
      </div>
      <InformationAbonnementModal
        v-if="isOpenModalInformationAbonnement"
        :is-open-modal-information-abonnement="isOpenModalInformationAbonnement"
        code-feature="FILTRE_COMPARAISON"
        texte="Affinez vos comparaisons en choisissant le type d'exploitation avec lequel vous souhaitez vous comparer."
        titre="Filtres de comparaison"
        @close="isOpenModalInformationAbonnement = false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AgrButton } from '@agrial/ui'
import AgrialSelect from '@/components/form/agrial-select.vue'
import BaseErrorMessage from '@/components/common/base-error-message.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageV2 from '@/components/common/base-message-v2.vue'
import ComparaisonRendement from '@/views/outils-analyse/components/comparaison-rendement.vue'
import EvolutionRendements from '@/views/outils-analyse/components/evolution-rendements.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'

export default {
  name: 'ComparaisonCulturesModal',
  components: {AgrButton , AgrialSelect, BaseErrorMessage, BaseLoader, BaseMessageV2, ComparaisonRendement, EvolutionRendements, InformationAbonnementModal},
  props: {
    titre: {
      type: String,
      default: null
    },
    culture: {
      type: Object,
      default: null
    },
    isOpenModalComparaison: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loading: {
        updateFiltres: false,
        comparaisonRendement: false,
        evolutionRendement: false
      },
      erreur: {
        updateFiltres: false,
        comparaisonRendement: false,
        evolutionRendement: false
      },
      regionAgrialSelected: null,
      typeExploitationSelected: null,
      typeProductionSelected: null,
      potentielSolSelected: null,
      ressourceEffluentSelected: null,
      stockeurSelected: null,
      isOpenModalInformationAbonnement: false,
    }
  },

  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      grainesContractualiseesEtRecoltees: 'graine/grainesContractualiseesEtRecoltees',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      filtresValeursPossibles: 'filtresComparaison/filtresValeursPossibles',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive'
    }),
        // Vérifie que la culture a des cultures correspondantes et que l'une d'elles est dans la liste des cultures ayant un apport et/ou un contrat
    hasBtnMesOutilsAnalyse () {
      let codesGraineRs3Correspondantes = this.culture.typeCulture.graineRs3Correspondantes.map(c => c.code)
      let codesGraineRs3 = this.grainesContractualiseesEtRecoltees.map(c => c.code)
      if (codesGraineRs3Correspondantes.length && codesGraineRs3.length) {
        return codesGraineRs3Correspondantes.some(i => codesGraineRs3.includes(i))
      }
      else {
        return false
      }
    },

  },

  created () {
    this.resetAllSelects()
    this.fetchAbonnements()
    this.loadEvolutionRendements()
    this.loadRepartitionRendement()
  },

  methods: {
    ...mapActions({
      fetchAbonnements: 'adherent/fetchAbonnements',
      getRendementsByNumtiersAndRecolteAndGraine: 'rendement/getRendementsByNumtiersAndRecolteAndGraine',
      getRendementsByNumtiersAndRecolteAndGraineGroupe: 'rendement/getRendementsByNumtiersAndRecolteAndGraineGroupe',
      getGrapheComparaisonCultureRendementMoyens: 'rendement/getGrapheComparaisonCultureRendementMoyens',
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      setFiltres: 'filtresComparaison/setFiltres'
    }),
    resetAllSelects () {
      this.typeExploitationSelected = this.filtresAdherent.typeExploitation
      this.typeProductionSelected = this.filtresAdherent.typeProduction
      this.potentielSolSelected = this.filtresAdherent.potentielSol
      this.ressourceEffluentSelected = this.filtresAdherent.ressourceEffluents
      this.stockeurSelected = this.filtresAdherent.stockeur
      this.regionAgrialSelected = this.filtresAdherent.regionsAgrial
    },
    updateFiltresAdherent () {
      this.loading.updateFiltres = true
      this.erreur.updateFiltres = false

      const filtresAUpdate = {
        typeExploitation: this.typeExploitationSelected,
        typeProduction: this.typeProductionSelected,
        potentielSol: this.potentielSolSelected,
        ressourceEffluents: this.ressourceEffluentSelected,
        stockeur: this.stockeurSelected,
        regionsAgrial: this.regionAgrialSelected
      }
      return this.setFiltres(filtresAUpdate)
        .then(() => {
          this.resetAllSelects()
          this.loadEvolutionRendements()
          this.loadRepartitionRendement()
        })
        .catch(() => this.erreur.updateFiltres = true)
        .finally(() => this.loading.updateFiltres = false)
    },
    isRendementIncoherent (culture) {
      const rendementMin = culture.typeCulture.rendementMinEnQuintauxParHectare || 0
      return culture.rendementEnQuintauxParHectare <= rendementMin || culture.rendementEnQuintauxParHectare > culture.typeCulture.rendementMaxEnQuintauxParHectare
    },
    loadEvolutionRendements () {
      this.erreur.evolutionRendement = false
      this.loading.evolutionRendement = true
      Promise.all([
        this.getRendementsByNumtiersAndRecolteAndGraine(this.codeGraineActive),
        this.getRendementsByNumtiersAndRecolteAndGraineGroupe(this.codeGraineActive)
        ])
        .catch(() => {
          this.erreur.evolutionRendement = true
        })
        .finally(() => {
          this.loading.evolutionRendement = false
        })
    },
    loadRepartitionRendement () {
      this.erreur.comparaisonRendement = false
      this.loading.comparaisonRendement = true

      this.getGrapheComparaisonCultureRendementMoyens(this.codeGraineActive)
        .catch(() => {
          this.erreur.comparaisonRendement = true
        })
        .finally(() => {
          this.loading.comparaisonRendement = false
        })
    },
    onPageOutilsAnalyse () {
      this.$router.push({ name: 'main.mes-outils-d-analyse' })
    },
    onAnyClickFiltres () {
      if (!this.abonnements.culturialAbonne) {
        this.isOpenModalInformationAbonnement = !this.isOpenModalInformationAbonnement
        this.incrementerAccesSouscriptionAbonnement('FILTRE_COMPARAISON')
      }
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
  background-color: #f1f2f5;
  overflow-y: auto;
}
.bg-titre {
  height: 70px;
}
.prepend-icon {
  z-index: 100;
}
.asterix {
  font-size: 0.875rem;
  color: var(--gris-fonce);
}
.input-multiple {
  height: 60px !important;
  overflow-y: scroll;
  padding-top: 5px;
  max-width: 300px;
}
.input-multiple-mobile {
  height: 60px !important;
  overflow-y: scroll;
  padding-top: 5px;
}
</style>
